<template>
  <div class="container_box">
    <!--tab栏-->
    <Tabs v-model="tabName" :animated="false" class="tabs_styles" @on-click="getList(true)">
      <TabPane v-for="item in tabList" :label="item.label" :name="item.name"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" @submit.native.prevent :label-width="labelWidth">
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005424')" prop="logisticsName">
              <Input v-model.trim="pageParams.logisticsName" clearable @on-enter="search()"></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box" v-if="getPermission('carrier_insertWithApi')">
      <Button type="primary" @click="$refs['addLogistics'].initLogisticsData()">{{ $t('key1005209') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="560"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--新增物流弹窗-->
    <addLogisticsModal ref="addLogistics" @updateData="updateData"></addLogisticsModal>
    <!--查看物流渠道-->
    <viewLogisticsChannel ref="viewLogisticsChannelDrawer" @updateData="updateData"></viewLogisticsChannel>
    <!--编辑账号弹窗-->
    <editAccountModal ref="editAccount" :countrysOriginalData="countrysOriginalData" @updateData="updateData"></editAccountModal>
    <!--适用范围弹窗-->
    <Modal v-model="scopeApplicationModal" :title="$t('key1005341')" width="500"
      :transfer="false" :mask-closable="false" @on-visible-change="scopeApplicationChange">
      <Form ref="scopeApplicationModalForm" :model="scopeApplicationModalForm" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
        <Row style="width: 80%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005351')" prop="platformId">
              <Select v-model="scopeApplicationModalForm.platformId" transfer filterable>
                <Option v-for="item in platformList" :key="item.platformId" :value="item.platformId">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="scopeApplicationModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="scopeApplicationBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--设置弹窗-->
    <Modal v-model="settingsModal" :title="$t('key1000669')" width="500" class-name="settingsModalStyles"
      :transfer="false" :mask-closable="false" @on-visible-change="settingsChange">
      <Form ref="settingsModalForm" :model="settingsModalForm" :label-width="130" @submit.native.prevent>
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="settingsLabel" prop="values" class="reset_radio_styles">
              <RadioGroup v-model="settingsModalForm.values">
                <Radio :label="1">{{ $t('key1000392') }}</Radio>
                <Radio :label="0">{{ $t('key1000393') }}</Radio>
              </RadioGroup>
            </Form-item>
          </Col>
          <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="labelRander(item)" :prop="'carrierName_' + item.code" :rules="getRules(item)">
                    <Input clearable :disabled="item.code === 'zh-CN'" v-model.trim="settingsModalForm['carrierName_' + item.code]"
                      style="width: 90%;"></Input>
                  </Form-item>
                </Col>
              </template>
            </template>
          </languagesTabs>
        </Row>
      </Form>
      <template #footer>
        <Button @click="settingsModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="settingsBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import addLogisticsModal from "@/views/yms/components/logisticsManage/addLogisticsModal";
import viewLogisticsChannel from "@/views/yms/components/logisticsManage/viewLogisticsChannel";
import editAccountModal from "@/views/yms/components/logisticsManage/editAccountModal";
import languagesTabs from "@/components/common/languagesTabs.vue";
import {_handleMultilingualFields, getAllCountrysData, getEnabledPlatforms, setConfigCharacters} from "@/utils/common";

export default {
  name: "basicLogistics",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParams: {
        logisticsName: ''
      },
      tableColumns: [],
      tableData: [],
      enableProviderData: [],
      settingsModal: false,
      settingsLabel: '',
      settingsModalForm: {
        values: 0
      },
      scopeApplicationModal: false,
      scopeApplicationModalForm: {
        platformId: null
      },
      platformList: [],
      carrierId: null,
      ruleValidate: {
        platformId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005415'), trigger: 'change'}
        ],
      },
      originalData: [],
      tabName: 'offlineLogistics',
      tabList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002256'), name: 'offlineLogistics'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002255'), name: 'onlineLogistics'}
      ],
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      countrysOriginalData: [],
    };
  },
  created() {
    getAllCountrysData().then((data) => {
      this.countrysOriginalData = data;
    });
    this.getPlatformList();
    this.getList(true);
  },
  methods: {
    // 获取适用范围的平台数据
    getPlatformList() {
      getEnabledPlatforms().then((data) => {
        if (data && data.length > 0) {
          this.platformList = data;
        }
      });
    },
    // 查询按钮
    search() {
      let v = this;
      v.tableData = [];
      // 前端--模糊搜索
      let logisticsName = v.pageParams.logisticsName;
      let newListData = [];
      if (logisticsName !== '') {
        let text = logisticsName.toLowerCase();
        if (v.originalData.length > 0) {
          v.originalData.filter(item => {
            if (item.carrierName.toLowerCase().indexOf(text) !== -1) {
              if (v.tabName === 'offlineLogistics') {
                if (item.isOnline === 0) {
                  newListData.push(item);
                }
              } else {
                if (item.isOnline === 1) {
                  newListData.push(item);
                }
              }
            }
          });
          v.tableData = newListData;
        }
      } else {
        v.tableData = v.originalData.filter(i => {
          if (v.tabName === 'offlineLogistics') {
            return i.isOnline === 0;
          } else {
            return i.isOnline === 1;
          }
        });
      }
    },
    // 列表查询的方法
    getList(value) {
      let v = this;
      v.tableData = [];
      v.optionBtnWidth = [];
      if (v.getPermission('carrier_queryForEnableCarriers')) {
        v.tableLoading = true;
        v.axios.get(api.get_carrier_queryForEnableCarriers).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                item.carrierAccountsLength = item.carrierAccounts ? item.carrierAccounts.length : 0;
                item.carrierName = _handleMultilingualFields(item.carrierName);
                item.name = _handleMultilingualFields(item.carrierName);
              });
              v.enableProviderData = JSON.parse(JSON.stringify(data));
              v.originalData = JSON.parse(JSON.stringify(data));
              if (value) {
                v.pageParams.logisticsName = '';
              }
              v.tableData = data.filter(i => {
                if (v.tabName === 'offlineLogistics') {
                  return i.isOnline === 0;
                } else {
                  return i.isOnline === 1;
                }
              });
              v.$nextTick(() => {
                v.tableLoading = false;
              });
              v.$forceUpdate();
            } else {
              v.tableData = [];
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.getList(true);
    },
    // 新增物流商、编辑自定义物流成功后，更新列表数据
    updateData(value) {
      this.search();
    },
    // 处理列表字段
    handleColumns(name) {
      let v = this;
      let columns = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005416'),
          key: 'name',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005417'),
          key: 'distributorUsageStatus',
          align: 'center',
          render(h, params) {
            let text = params.row.distributorUsageStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005418'),
          key: 'carrierAccountsLength',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005419'),
          key: 'applicablePlatform',
          align: 'center',
          render(h, params) {
            let list = '';
            let extendJson = params.row.extendJson;
            if (extendJson) {
              list = (JSON.parse(extendJson)).join('、');
            }
            return h('span', {
              style: {
                textTransform: 'capitalize'
              }
            }, list);
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000418')}`,
          key: 'coreUsageStatus',
          align: 'center',
          render(h, params) {
            let text = params.row.coreUsageStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005420'),
          key: 'carrierType',
          align: 'center',
          render(h, params) {
            let carrierType = params.row.carrierType;
            let name = carrierType === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005208') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003797');
            return h('div', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'opts',
          align: 'center',
          width: 280,
          render(h, params) {
            let carrierName = params.row.carrierName;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005421'),
                    show: v.getPermission('carrierAccount_save'),
                    clickFn: () => {
                      v.$refs['editAccount'].initAccountData(params.row, v.enableProviderData);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005257'),
                    show: v.getPermission('carrierShippingMethod_queryForEnableShippingMethods'),
                    clickFn: () => {
                      v.$refs['viewLogisticsChannelDrawer'].initViewLogisticsChannelData(params.row);
                      v.$store.commit('carrierName', carrierName);
                      let carrierAccountId = params.row.carrierAccounts ? params.row.carrierAccounts[0].carrierAccountId : null;
                      v.$store.commit('carrierAccountId', carrierAccountId);
                      v.$store.commit('formInlineInfo', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000669'),
                    show: true,
                    clickFn: () => {
                      v.initSettingsData(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005422'),
                    show: v.tabName === 'onlineLogistics',
                    clickFn: () => {
                      v.carrierId = params.row.carrierId;
                      let extendJson = params.row.extendJson;
                      if (extendJson) {
                        v.scopeApplicationModalForm.platformId = JSON.parse(extendJson)[0];
                      } else {
                        v.scopeApplicationModalForm.platformId = null;
                      }
                      v.scopeApplicationModal = true;
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      let keyList = [];
      // 线下物流
      if (name === 'offlineLogistics') {
        v.settingsLabel = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005423');
        keyList = [
          'name',
          'distributorUsageStatus',
          'carrierAccountsLength',
          'carrierType',
          'opts'
        ];
      }
      // 线上物流
      else {
        v.settingsLabel = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005414')}`;
        keyList = [
          'name',
          'applicablePlatform',
          'coreUsageStatus',
          'carrierType',
          'opts'
        ];
      }
      v.tableColumns = columns.filter((item) => {
        return keyList.includes(item.key);
      });
      v.$forceUpdate();
    },
    // 设置弹窗的确定按钮
    settingsBtn() {
      let v = this;
      let query = {
        carrierId: v.carrierId
      };
      let url = '';
      // 线下
      if (v.tabName === 'offlineLogistics') {
        url = api.post_carrier_updateDistributorUsage;
        query.distributorUsageStatus = v.settingsModalForm.values;
      }
      // 线上
      else {
        url = api.post_carrier_coreUsageStatus;
        query.coreUsageStatus = v.settingsModalForm.values;
      }
      query.carrierName = v.handleMultilingualSingleParam(v.settingsModalForm, 'carrierName_');
      v.$refs['settingsModalForm'].validate((valid, err) => {
        if (valid) {
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
            if (response.data.code === 0) {
              v.settingsModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.getList();
            }
          });
        }
      });
    },
    // 适用范围弹窗的确定按钮
    scopeApplicationBtn() {
      let v = this;
      let query = `?carrierId=${v.carrierId}&platforms=${[v.scopeApplicationModalForm.platformId]}`;
      v.$refs['scopeApplicationModalForm'].validate((valid) => {
        if (valid) {
          v.axios.put(api.put_carrier_saveUsePlatform + query, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
            if (response.data.code === 0) {
              v.scopeApplicationModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.getList();
            }
          });
        }
      });
    },
    // 监听设置弹窗
    settingsChange(value) {
      if (!value) {
        this.carrierId = null;
        this.$refs['settingsModalForm'].resetFields();
      }
    },
    // 监听适用范围的弹窗
    scopeApplicationChange(value) {
      if (!value) {
        this.$refs['scopeApplicationModalForm'].resetFields();
      }
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    },
    // 初始化设置的数据
    initSettingsData(item) {
      let v = this;
      v.carrierId = item.carrierId;
      v.axios.get(api.get_carrier + item.carrierId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.$refs['languagesTab'].tabName = v.languagesVal;
            if (v.tabName === 'offlineLogistics') {
              v.settingsModalForm.values = data.distributorUsageStatus;
            } else {
              v.settingsModalForm.values = data.coreUsageStatus;
            }
            v.initMultilingualFields('settingsModalForm', v.settingsModalForm, ['carrierName_']).then(() => {
              let obj = v.handleMultilingualFormFields(data, ['carrierName']);
              v.settingsModalForm = Object.assign({}, v.settingsModalForm, obj);
              v.settingsModal = true;
              v.$forceUpdate();
            });
          }
        }
      });
    }
  },
  watch: {
    // 监听tab栏的变化
    tabName: {
      handler(value) {
        this.handleColumns(value);
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    languagesTabs,
    addLogisticsModal,
    viewLogisticsChannel,
    editAccountModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .settingsModalStyles {
  .reset_radio_styles {
    .ivu-form-item-label {
      font-size: 14px;
      padding-top: 11px;
    }
  }
}

.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 0;
    margin: 0;
  }
}
</style>
